import { render, staticRenderFns } from "./kv.vue?vue&type=template&id=83df1384&scoped=true&"
import script from "./kv.vue?vue&type=script&lang=js&"
export * from "./kv.vue?vue&type=script&lang=js&"
import style0 from "./kv.vue?vue&type=style&index=0&id=83df1384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df1384",
  null
  
)

export default component.exports